import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { ITextCoverBlockData } from './ITextCoverBlockData';

export const DynamicTextCoverBlock = dynamic<BlockProps<ITextCoverBlockData>>(
    () => import('./TextCoverBlock').then(md => md.TextCoverBlock),
);
